<template>
  <b-modal
    centered
    size="md"
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    v-model="form.show">
    <template #modal-header="{}">
      <div class="header flex-grow-1 text-center">
        <h2 class="font-weight-bold">เพิ่มพนักงาน</h2>
      </div>
      <span class="close cursor-pointer" @click="form.show = false"
        >&times;</span
      >
    </template>
    <ValidationObserver ref="observer">
      <b-form @submit="onSubmit">
        <card shadow type="secondary" class="m--4">
          <b-row>
            <b-col cols="12">
              <ValidationProvider rules="required|email" v-slot="{ errors }">
                <b-form-group label="อีเมล">
                  <b-form-input
                    placeholder="อีเมล"
                    v-model="form.driver.username"
                    :state="!errors.length ? null : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="12">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-group label="รหัสผ่าน">
                  <b-form-input
                    placeholder="รหัสผ่าน"
                    v-model="form.driver.password"
                    type="password"
                    :state="!errors.length ? null : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="12">
              <hr class="my-3" />
            </b-col>
            <b-col cols="6">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-group label="ชื่อ">
                  <b-form-input
                    placeholder="ชื่อ"
                    v-model="form.driver.firstName"
                    :state="!errors.length ? null : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="6">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-group label="นามสกุล">
                  <b-form-input
                    placeholder="นามสกุล"
                    v-model="form.driver.lastName"
                    :state="!errors.length ? null : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="12">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-group label="เบอร์โทรศัพท์">
                  <b-form-input
                    placeholder="08XXXXXXXX"
                    v-model="form.driver.tel"
                    :state="!errors.length ? null : false" />
                  <b-form-invalid-feedback>
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col cols="12">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                tag="div">
                <b-form-group label="เลือกรถ">
                  <multiselect
                    v-model="form.driver.car"
                    deselect-label="Can't remove this value"
                    track-by="id"
                    label="plate"
                    placeholder="ค้นหารถ"
                    :options="listCar"
                    :allow-empty="false"
                    :class="{
                      'custom-select-error': errors[0],
                    }">
                    <template slot="option" slot-scope="{ option }">
                      <strong>{{ option.plate }} </strong>
                      <strong>( {{ option.drive_system }} )</strong>
                    </template>
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong>{{ option.plate }} </strong>
                      <strong>( {{ option.drive_system }} )</strong>
                    </template>
                  </multiselect>
                  <p class="custom-meassage-error" v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-row class="justify-content-between">
              <b-col cols="4">
                <b-button block @click="closeModalConfirm()"> ยกเลิก </b-button>
              </b-col>
              <b-col cols="8">
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  :disabled="form.isLoad">
                  <i class="fas fa-circle-notch fa-spin" v-if="form.isLoad"></i>
                  ยืนยัน
                </b-button>
              </b-col>
            </b-row>
          </template>
        </card>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from "@/util/alert.js";
import driverServices from "@/api/driver.service.js";

export default {
  props: {
    form: {
      type: Object,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      listCar: [],
    };
  },
  mounted() {
    this.getListCar();
  },
  methods: {
    async getListCar() {
      try {
        const { data } = await driverServices.getListCar({ status: "active" });
        this.listCar = data.data;
      } catch (error) {
      } finally {
      }
    },
    async onSubmit(event) {
      event.preventDefault();
      const isValid = await this.$refs.observer.validate();

      if (!isValid) {
        return;
      }

      const { username, password, firstName, lastName, tel, car } =
        this.form.driver;
      const payload = {
        email: username,
        password: password,
        firstname: firstName,
        lastname: lastName,
        phonenumber: tel,
        vehicle_id: car.id,
      };

      try {
        await driverServices.createDriver(payload);

        modalSuccess(this.$bvModal, "เพิ่มพนักงานขับรถสำเร็จ");
        await this.$emit("getDriver");
        this.closeModalConfirm();
      } catch (err) {
        modalError(this.$bvModal, "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      } finally {
        await this.getListCar();
      }
    },
    closeModalConfirm() {
      this.$refs.observer.reset();
      this.form.show = false;
      this.form.isLoad = false;
      this.form.driver = {
        username: null,
        password: null,
        firstName: null,
        lastName: null,
        tel: null,
        noCar: null,
        typeCar: null,
      };
    },
  },
};
</script>
